import styled from "styled-components";

export const CardBodyCustom = styled.div`
  display: flex;
  justify-content: center;
`;
